import React from 'react';
import './styles.scss';
function Spinner(props) {
  return <div className="spinner" {...props}></div>;
}

export default React.memo(Spinner);
